// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2stkd","approved":"Status_approved__1B28o","rejected":"Status_rejected__BX-Qo","expired":"Status_expired__2ue1J","label":"Status_label__11OPT"};